class DateInputMask {
  constructor(inputElement) {
    this.inputElement = inputElement;
    this.ignoreNextInput = false;
    this.lastKeyEntered = undefined;
    this.handleKeyDown = (event) => {
      this.lastKeyEntered = event.key;
      switch (event.key) {
        case "Left": // IE/Edge specific value
        case "ArrowLeft":
        case "Right": // IE/Edge specific value
        case "ArrowRight":
        case "Backspace":
        case "Del": // IE/Edge specific value
        case "Delete":
          this.ignoreNextInput = true;
          return;
      }
      if (event.key !== 'Tab' && event.key !== '/' && !event.key.match(/\d/)) {
        event.preventDefault();
      }
    };
    this.handleInput = () => {
      if (this.ignoreNextInput === true) {
        this.ignoreNextInput = false;
      }
      else {
        let elementValue = this.inputElement.value;
        // Remove slash if user types it
        if (this.lastKeyEntered === '/' && elementValue[elementValue.length - 1] === '/') {
          elementValue = elementValue.slice(0, -1);
        }
        // Automatically append slash
        if (elementValue.length === 2 || elementValue.length === 5) {
          elementValue = elementValue + '/';
        }
        else if (elementValue.length === 3 && elementValue[2] !== '/') {
          elementValue = elementValue.substring(0, 2) + "/" + elementValue[2];
        }
        else if (elementValue.length === 6 && elementValue[5] !== '/') {
          elementValue = elementValue.substring(0, 5) + "/" + elementValue[5];
        }
        this.inputElement.value = elementValue;
      }
    };
  }
  static mask(inputElement) {
    const mask = new DateInputMask(inputElement);
    mask.attachListeners();
    return mask;
  }
  attachListeners() {
    this.inputElement.addEventListener('keydown', this.handleKeyDown);
    this.inputElement.addEventListener('input', this.handleInput);
  }
  removeListeners() {
    this.inputElement.removeEventListener('keydown', this.handleKeyDown);
    this.inputElement.removeEventListener('input', this.handleInput);
  }
}

export { DateInputMask as D };
